import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import Tile from 'srcReact/components/common2/Tile'
import styles from './styles.module.scss'
import { createUpdateGroupActions } from 'srcReact/GroupPage'

const WorkplaceSelection = ({ show, containerCss, verticalLineCss, infoCss, titleCss }) => {
  const [selectedWP, setSelectedWP] = useState({})
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const {
    createUpdateGroup: { selectedWorkplace, workplaces, isGeneralGroup },
    login: { user },
    common: { isMobile }
  } = useSelector((state) => state)

  useEffect(() => {
    if (workplaces.length === 1) {
      setSelectedWP(workplaces[0])
    }
  }, [workplaces])

  const selectWP = (workplace) => {
    if (selectedWP.id === workplace.id) {
      setSelectedWP({})
    } else {
      setSelectedWP(workplace)
    }
  }

  useEffect(() => {
    if (workplaces.length === 1) {
      setSelectedWP(workplaces[0])
    }
  }, [workplaces])

  useEffect(() => {
    if (!isGeneralGroup) {
      dispatch(createUpdateGroupActions.setSelectedWorkplace(selectedWP))
      if (selectedWP && selectedWP.id > 0) {
        dispatch(createUpdateGroupActions.showGroupType())
      }
    }
  }, [selectedWP, dispatch])

  return selectedWorkplace ? (
    isGeneralGroup ? (
      <div className={`${containerCss} ${styles.subContainer}`}>
        <div className={` ${styles.content}`}>
          <Tile color={selectedWorkplace.color} size='medium'>
            <span className={styles.selectedWPText}>{selectedWorkplace.name}</span>
          </Tile>
        </div>
      </div>
    ) : (
      <div className={`${containerCss} ${styles.subContainer} ${show ? styles.show : styles.hide}`}>
        {workplaces.length > 1 && (
          <p className={`${infoCss} ${styles.para}`}>
            {t('group.createGroup.workplace.title1', {
              name: user ? user.firstname : ''
            })}
          </p>
        )}
        <div class={verticalLineCss}></div>

        <div className={styles.container}>
          {workplaces.length > 1 ? (
            <label className={titleCss}>{t('group.createGroup.workplace.title2')}</label>
          ) : workplaces.length === 1 ? (
            <label className={titleCss}>{t('group.createGroup.workplace.title2SingleWP')}</label>
          ) : null}

          <div className={styles.content}>
            {workplaces.length > 1 ? (
              workplaces.map((wp) => (
                <button
                  key={wp.id}
                  className={styles.buttonTile}
                  type='button'
                  onClick={() => {
                    selectWP(wp)
                  }}>
                  <Tile
                    color={
                      selectedWP.id === wp.id || (selectedWorkplace && selectedWorkplace.id === wp.id)
                        ? wp.color
                        : 'gray'
                    }
                    size='medium'>
                    <span className={`${styles.wpText} ${selectedWP.id === wp.id && styles.selectedWPText}`}>
                      {wp.name}
                    </span>
                  </Tile>
                </button>
              ))
            ) : workplaces.length === 1 ? (
              <div className={`${styles.buttonTile} ${styles.singleWorkplace}`}>
                <Tile color={workplaces[0].color} size='medium'>
                  <span className={`${styles.wpText} ${styles.selectedWPText}`}>{workplaces[0].name}</span>
                </Tile>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    )
  ) : null
}

export default WorkplaceSelection
